import { LogType } from 'src/system/content/models/LogType'
import ILogService from 'src/system/content/services/ILogService'
import ILogApiRequest from 'src/system/content/api/ILogApiRequest'
import IRemoteContentService from 'src/system/content/services/IRemoteContentService'

export class LogService implements ILogService {
  constructor(private readonly remoteContentService: IRemoteContentService) {
    //
  }

  async log(type: LogType, payload?: ILogApiRequest): Promise<void> {
    if (typeof payload === 'undefined') {
      payload = { data: JSON.stringify({}) }
    } else if (typeof payload.data === 'object') {
      payload.data = JSON.stringify(payload.data)
    }

    this.remoteContentService
      .request('POST', '/api/log/create', { log_type_id: type, ...payload })
      .then((response) => {
        if (response.status >= 300 || response.status < 200) {
          console.warn('LogService.log: Failed to log message', response)
        } else {
          console.debug('LogService.log: Message logged successfully', response.data)
        }
      })
      .catch((error) => {
        console.warn('LogService.log: Failed to log message', error)
      })
  }
}
